import api from './api';

const sacMasterService = {
  // Get all SAC master records
  getAllSACs: async (filters = {}) => {
    try {
      const params = new URLSearchParams(filters).toString();
      const response = await api.get(`/sac-master?${params}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching all SAC master records:', error);
      throw error;
    }
  },

  // Get a single SAC master record by ID
  getSACById: async (id) => {
    try {
      const response = await api.get(`/sac-master/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching SAC master record with ID ${id}:`, error);
      throw error;
    }
  },

  // Create a new SAC master record
  createSAC: async (sacData) => {
    try {
      const response = await api.post('/sac-master', sacData);
      return response.data;
    } catch (error) {
      console.error('Error creating SAC master record:', error);
      throw error;
    }
  },

  // Update an existing SAC master record
  updateSAC: async (id, sacData) => {
    try {
      const response = await api.put(`/sac-master/${id}`, sacData);
      return response.data;
    } catch (error) {
      console.error(`Error updating SAC master record with ID ${id}:`, error);
      throw error;
    }
  },

  // Delete a SAC master record
  deleteSAC: async (id) => {
    try {
      const response = await api.delete(`/sac-master/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting SAC master record with ID ${id}:`, error);
      throw error;
    }
  },

  // Get SAC master statistics
  getSACStats: async () => {
    try {
      const response = await api.get('/sac-master/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching SAC master stats:', error);
      throw error;
    }
  },

  // Get SACs by status
  getSACsByStatus: async (status) => {
    try {
      const response = await api.get(`/sac-master/status/${status}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching SACs by status ${status}:`, error);
      throw error;
    }
  },

  // Get active SACs
  getActiveSACs: async () => {
    try {
      const response = await api.get('/sac-master/active');
      return response.data;
    } catch (error) {
      console.error('Error fetching active SACs:', error);
      throw error;
    }
  },
};

export default sacMasterService;
